import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import plural from "@/features/plural";
  import CheckboxInput from "../input/CheckboxInput.vue";
  import { BuilderInterfaceWithHouseDesigns } from "@/types/BuilderInterface";
  import {
    HouseDesignInterface,
    FacadeInterface,
  } from "@/types/HouseDesignInterface";
  import { BuilderAndHouses, HousesAndSiteCosts } from "@/types/LotInterface";
  import {
    formatPriceTrim,
    updatePriceInput,
  } from "@/helpers/transformation/price";

  interface FacadeOption {
    _id: string;
    name: string;
    isSelected: boolean;
  }

  interface House extends HouseDesignInterface {
    isSelected: boolean;
    siteCosts: number;
    selectedFacadeIds: string[];
  }
  interface BuilderProp extends BuilderInterfaceWithHouseDesigns {
    isSelected: boolean;
    houses: House[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectBuildersLotModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    builders: {
      type: Array as PropType<BuilderProp[]>,
      required: true,
    },
    buildersLot: {
      type: Array as PropType<BuilderAndHouses[]>,
      required: false,
    },
    showFacades: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close", "save"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const buildersList = computed<BuilderProp[]>(() => props.builders);
  const emits = __emit;

  const canSave = computed(() => {
    const selectedBuilders = buildersList.value.filter(
      (builder) => builder.isSelected
    );
    const buildersWithHousesSelected = selectedBuilders.flatMap((builder) =>
      builder.houses.filter((house) => house.isSelected)
    );

    return buildersWithHousesSelected.length;
  });

  const toggleFacade = (house: House, facadeId: string) => {
    if (!house.selectedFacadeIds) house.selectedFacadeIds = [];

    const idx = house.selectedFacadeIds.indexOf(facadeId);

    if (idx === -1) {
      house.selectedFacadeIds.push(facadeId);
    } else {
      house.selectedFacadeIds.splice(idx, 1);
    }
  };

  const getSiteCosts = (house: House) => {
    if (house.siteCosts || house.siteCosts === 0) {
      return formatPriceTrim(house.siteCosts);
    }

    if (!props.buildersLot) {
      return "$0";
    }

    let houseWithSiteCosts: HousesAndSiteCosts | undefined = undefined;

    props.buildersLot.some((builder) => {
      return builder.housesIds.some((houseId) => {
        if (houseId.houseId === house._id) {
          houseWithSiteCosts = houseId;
          return true;
        }

        return false;
      });
    });

    if (houseWithSiteCosts) {
      house.siteCosts = houseWithSiteCosts?.siteCosts;
    } else if (house.basePrice) {
      house.siteCosts = house.basePrice;
    }

    return formatPriceTrim(house.siteCosts);
  };

  const getBuildersSelectedCount = computed(() => {
    return buildersList.value.filter(
      (builder: BuilderProp) => builder.isSelected
    ).length;
  });
  const onSave = () => {
    const selectedBuilders = buildersList.value
      .filter((builder) => builder.isSelected)
      .map((builder) => ({
        builderId: builder._id,
        housesIds: builder.houses
          .filter((house) => house.isSelected)
          .map((house) => ({
            houseId: house._id,
            siteCosts: house.siteCosts || null,
            ...(props.showFacades && house.selectedFacadeIds?.length
              ? { facadeIds: house.selectedFacadeIds }
              : {}),
          })),
      }));

    emits("save", selectedBuilders);
    emits("close");
  };

  const onClose = () => {
    emits("close");
  };

const __returned__ = { props, buildersList, emits, canSave, toggleFacade, getSiteCosts, getBuildersSelectedCount, onSave, onClose, PropType, computed, Modal, get plural() { return plural }, CheckboxInput, get BuilderInterfaceWithHouseDesigns() { return BuilderInterfaceWithHouseDesigns }, get HouseDesignInterface() { return HouseDesignInterface }, get FacadeInterface() { return FacadeInterface }, get BuilderAndHouses() { return BuilderAndHouses }, get HousesAndSiteCosts() { return HousesAndSiteCosts }, get formatPriceTrim() { return formatPriceTrim }, get updatePriceInput() { return updatePriceInput } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})